import React from 'react';
import './index.scss';

/**
 * 博客页面通用模块容器组件
 * @param {Object} props
 * @param {string} props.title - 模块标题
 * @param {React.ReactNode} props.children - 模块内容
 * @param {React.ReactNode} props.actions - 模块操作按钮
 * @param {string} props.variant - 模块变体 ('info' | 'editor' | 'list' | 'data' | 'settings')
 * @param {string} props.className - 额外的CSS类名
 * @param {Object} props.style - 内联样式
 * @param {boolean} props.noPadding - 是否移除内容区域的内边距
 * @param {React.ReactNode} props.headerExtra - 标题旁边的额外内容
 */
const ModuleSection = ({
  title,
  children,
  actions,
  variant = 'default',
  className = '',
  style,
  noPadding = false,
  headerExtra,
  ...props
}) => {
  const moduleClass = [
    'module-section',
    `module-${variant}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={moduleClass} style={style} {...props}>
      {title && (
        <div className="section-header">
          <div className="header-left">
            <h4>{title}</h4>
            {headerExtra && <div className="header-extra">{headerExtra}</div>}
          </div>
          {actions && (
            <div className="section-actions">
              {actions}
            </div>
          )}
        </div>
      )}
      <div className={`section-content ${noPadding ? 'no-padding' : ''}`}>
        {children}
      </div>
    </div>
  );
};

export default ModuleSection;
